export enum DATE_FORMATS {
  FullDateTime = 'D MMM YYYY hh:mma',

  DayMonthYear = 'D MMM YYYY',

  DayMonthYearWithFullDay = 'dddd, D MMM YYYY',

  DayMonth = 'D MMM',

  Day = 'D',

  DayOfWeek = 'ddd',

  Hour = 'h a',

  HourMinute = 'hh:mma',

  HourMinuteSecond = 'hh:mm:ssa',

  HourMinuteSecond24Hour = 'HH:mm:ss',

  DayMonthHour = 'D MMM hh:mma',

  YearMonthDayIso = 'YYYY-MM-DD'
};